var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import isEmpty from 'lodash/isEmpty';
import Header from './Header';
import Pagination from './Pagination';
import EditableRow from './EditableRow';
/**
 * Table component. Components for rendering head and body rows should be passed as props
 *
 * **Functional Spec:** https://github.com/invotra/invotra-components-spec/blob/develop/v0.3.0/components/datatable.md
 */
var Table = /** @class */ (function (_super) {
    __extends(Table, _super);
    function Table(props) {
        var _this = _super.call(this, props) || this;
        _this.handleSelectAllChange = function (checked) {
            var selected = checked ? _this.props.data : [];
            _this.props.onSelectChange && _this.props.onSelectChange(selected);
            _this.setState({ selected: selected });
        };
        _this.handleSelectClick = function (row, checked) {
            var selected = checked ? _this.state.selected.concat([row]) : _this.state.selected.filter(function (item) { return item !== row; });
            _this.props.onSelectChange && _this.props.onSelectChange(selected);
            _this.setState({ selected: selected });
        };
        _this.checkSelected = function (row) {
            return _this.state.selected.findIndex(function (item) { return item === row; }) !== -1;
        };
        _this.handleChangePage = function (page) {
            _this.setState({ selected: [] });
            // TODO: Replace it with fetching data from server
            _this.props.handleChangePage(page);
        };
        _this.handleChangeLimit = function (limit) {
            _this.setState({ selected: [] });
            // TODO: Replace it with fetching data from server
            _this.props.handleChangeLimit(+limit);
        };
        _this.handleSort = function (orderBy) {
            var newFilters = orderBy !== _this.props.filters.sort ? {
                sort: orderBy,
                order: 'desc',
            } : {
                sort: orderBy,
                order: _this.props.filters.order === 'asc' ? 'desc' : 'asc',
            };
            _this.setState({ selected: [] });
            // TODO: Replace it with fetching data from server
            _this.props.handleSort(newFilters);
        };
        _this.setOpen = function (row, open) {
            _this.setState({
                open: open ? row : null
            });
        };
        _this.headerCheckBoxValue = function () {
            if (isEmpty(_this.state.selected) || isEmpty(_this.props.data)) {
                return -1;
            }
            if (_this.state.selected.length < _this.props.data.length) {
                return 0;
            }
            return 1;
        };
        _this.state = {
            selected: [],
            open: null
        };
        return _this;
    }
    Table.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        // TODO: Uncomment this string when server interaction is ready
        // return this.props.data !== nextProps.data || this.state.selected !== nextState.selected
        return true;
    };
    Table.prototype.renderSelectedInfo = function () {
        var selectedLength = this.state.selected.length;
        if (selectedLength === 1) {
            return '1 item is selected';
        }
        if (selectedLength > 0) {
            return selectedLength + " items are selected";
        }
        return null;
    };
    Table.prototype.render = function () {
        var _this = this;
        var _a = this.props, head = _a.head, data = _a.data, selectable = _a.selectable, editable = _a.editable, Form = _a.Form, count = _a.count, offset = _a.offset, limit = _a.limit, filters = _a.filters, Row = _a.renderRow, _b = _a.className, className = _b === void 0 ? '' : _b;
        var sortedData = data;
        var sort = filters.sort, order = filters.order;
        if (sort) {
            sortedData = data.sort(function (a, b) {
                return a[sort] > b[sort]
                    ? (order === 'asc' ? 1 : -1)
                    : (order === 'asc' ? -1 : 1);
            });
        }
        return (React.createElement("div", { className: "mdc-data-table madonna-table " + className },
            React.createElement("table", { className: "mdc-data-table__table", "aria-label": "Dessert calories" },
                React.createElement("thead", null,
                    React.createElement(Header, { cells: head, checked: this.headerCheckBoxValue(), selectable: selectable, filters: filters, handleSort: this.handleSort, handleSelectAllChange: function (checked) { _this.handleSelectAllChange(checked); } })),
                React.createElement("tbody", { className: "mdc-data-table__content" }, sortedData.map(function (item, key) { return (React.createElement(Row, { key: "data-table-row-" + key, cells: item, selected: _this.checkSelected(item), selectable: selectable, handleSelectClick: function (checked) { _this.handleSelectClick(item, checked); }, open: _this.state.open === item, setOpen: function (open) { return _this.setOpen(item, open); }, editable: editable, Form: Form })); })),
                React.createElement("tfoot", null,
                    React.createElement("tr", { className: "mdc-data-table__row madonna-simple-row" },
                        React.createElement("td", { className: "mdc-data-table__cell madonna-footer-cell", colSpan: head.length + (selectable ? 1 : 0) },
                            React.createElement("div", { className: "madonna-footer-inner" },
                                React.createElement("div", { className: "selected-info" }, this.renderSelectedInfo()),
                                React.createElement(Pagination, { offset: offset, limit: limit, count: count, handleChangePage: function (page) { _this.handleChangePage(page); }, handleChangeLimit: function (limit) { _this.handleChangeLimit(limit); } }))))))));
    };
    Table.defaultProps = {
        renderRow: EditableRow,
    };
    return Table;
}(React.Component));
export default Table;
//# sourceMappingURL=Table.js.map